/* GS-COM sale countdown (homepage section "gs-sale-countdown" and site-wide "gs-sale-bar").
   Markup contract (set by the sections):
     [data-gs-countdown]            root, with data-start / data-end (ISO 8601 with offset, e.g. 2026-11-27T00:00:00-06:00)
       data-label-before / data-label-during   text shown before / during the sale
       data-hide-after="true"       hide the root once the sale has ended
     [data-gs-label]                receives the before/during label
     [data-gs-days|hours|minutes|seconds]  receive the numbers
     [data-gs-emoji] with data-emojis="🔥|🛍️|⏰"  cycles through the emojis
   Sale bar only: [data-gs-sale-bar] root, [data-gs-close] button, data-dismiss-key (localStorage key). */
(function () {
  if (window.gsSale) return;

  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  function initCountdown(root) {
    if (!root || root.gsCountdownTimer) return;
    var start = Date.parse(root.getAttribute('data-start'));
    var end = Date.parse(root.getAttribute('data-end'));
    if (isNaN(start) || isNaN(end)) return;

    var labelEl = root.querySelector('[data-gs-label]');
    var parts = {
      days: root.querySelector('[data-gs-days]'),
      hours: root.querySelector('[data-gs-hours]'),
      minutes: root.querySelector('[data-gs-minutes]'),
      seconds: root.querySelector('[data-gs-seconds]')
    };

    function tick() {
      var now = Date.now();
      var phase, target;
      if (now < start) { phase = 'before'; target = start; }
      else if (now < end) { phase = 'during'; target = end; }
      else { phase = 'ended'; target = now; }

      root.setAttribute('data-phase', phase);
      if (phase === 'ended') {
        clearInterval(root.gsCountdownTimer);
        if (root.getAttribute('data-hide-after') === 'true') root.hidden = true;
        return;
      }
      if (labelEl) labelEl.textContent = root.getAttribute('data-label-' + phase) || '';

      var s = Math.max(0, Math.floor((target - now) / 1000));
      if (parts.days) parts.days.textContent = Math.floor(s / 86400);
      if (parts.hours) parts.hours.textContent = pad(Math.floor(s % 86400 / 3600));
      if (parts.minutes) parts.minutes.textContent = pad(Math.floor(s % 3600 / 60));
      if (parts.seconds) parts.seconds.textContent = pad(s % 60);
      root.classList.add('is-ready');
    }

    tick();
    root.gsCountdownTimer = setInterval(tick, 1000);
  }

  function initEmojis(scope) {
    var els = (scope || document).querySelectorAll('[data-gs-emoji]');
    Array.prototype.forEach.call(els, function (el) {
      if (el.gsEmojiTimer) return;
      var list = (el.getAttribute('data-emojis') || '').split('|').filter(Boolean);
      if (list.length < 2) return;
      var i = 0;
      el.gsEmojiTimer = setInterval(function () {
        i = (i + 1) % list.length;
        el.classList.remove('is-pop');
        void el.offsetWidth; /* restart the pop animation */
        el.textContent = list[i];
        el.classList.add('is-pop');
      }, 2500);
    });
  }

  function initBar(bar) {
    if (!bar || bar.gsBarReady) return;
    bar.gsBarReady = true;
    var key = bar.getAttribute('data-dismiss-key');
    var dismissed = false;
    try { dismissed = key && window.localStorage.getItem(key) === '1'; } catch (e) {}
    if (dismissed && !window.Shopify?.designMode) { bar.hidden = true; return; }

    var close = bar.querySelector('[data-gs-close]');
    if (close) close.addEventListener('click', function () {
      bar.classList.remove('is-open');
      try { if (key) window.localStorage.setItem(key, '1'); } catch (e) {}
      setTimeout(function () { bar.hidden = true; }, 350);
    });

    var cd = bar.matches('[data-gs-countdown]') ? bar : bar.querySelector('[data-gs-countdown]');
    initCountdown(cd);
    if (bar.hidden) return; /* sale over */
    requestAnimationFrame(function () { setTimeout(function () { bar.classList.add('is-open'); }, 400); });
  }

  function initAll(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-gs-sale-bar]'), initBar);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-gs-countdown]:not([data-gs-sale-bar])'), initCountdown);
    initEmojis(scope);
  }

  window.gsSale = { init: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  /* Re-run when a section is added or edited in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
